/**
 * A base class for handling form elements.
 */

import CLASS_NAMES from "@js/constants/css-constants.es6.js";
import {ATTRIBUTES} from "@js/constants/html-constants.es6.js";
import Element from "@js/core/element.es6.js";
import Field from "@js/core/field.es6.js"
import Paragraph from "@js/core/paragraph.es6.js";

export default class FormElementParagraph extends Paragraph {
  get element() {
    return new Element({
      parentElement: this,
      selector: `.${CLASS_NAMES.FORM_ELEMENT}`,
    });
  }

  get errorMessage() {
    return new Field({
      machineName: 'field_error_message',
      parentElement: this,
    });
  }

  get required() {
    return this.element.$().prop(ATTRIBUTES.REQUIRED);
  }

  get value() {
    const value = this.element.$().val();
    return value || null;
  }

  get hasValue() {
    return this.value?.length > 0;
  }

  toggleRequirement(required) {
    this.toggleElementRequirement(required);
    this.label.paragraph.toggleRequirement(required);
  }

  toggleElementRequirement(required) {
    const $formElement = this.element.$();
    if (required) {
      $formElement.attr(ATTRIBUTES.REQUIRED, true);
    } else {
      $formElement.removeAttr(ATTRIBUTES.REQUIRED);
    }
  }

  toggleErrorByVisibility(show) {
    const $field = this.$();
    const $errorMessage = this.errorMessage.$();

    this.#toggleAccessibilityError(show);

    if (show) {
      $field.addClass(CLASS_NAMES.ERROR);
      $errorMessage.css('visibility', 'visible');
    } else {
      $field.removeClass(CLASS_NAMES.ERROR);
      $errorMessage.css('visibility', 'hidden');
    }
  }

  toggleErrorByDisplay(show) {
    const $field = this.$();
    const $errorMessage = this.errorMessage.$();

    this.#toggleAccessibilityError(show);

    if (show) {
      $field.addClass(CLASS_NAMES.ERROR);
      $errorMessage.css('display', 'inline-flex');
    } else {
      $field.removeClass(CLASS_NAMES.ERROR);
      $errorMessage.css('display', 'none');
    }
  }

  #toggleAccessibilityError(show) {
    const $element = this.element.$();

    if (show) {
      $element.attr(ATTRIBUTES.ARIA_INVALID, 'true');

      const id = $element.attr(ATTRIBUTES.ID);
      const errorMessageId = `${id.split('--')[0]}-error-message`;
      $element.attr(ATTRIBUTES.ARIA_ERRORMESSAGE, errorMessageId);
    } else {
      $element.attr(ATTRIBUTES.ARIA_INVALID, 'false');
      $element.removeAttr(ATTRIBUTES.ARIA_ERRORMESSAGE);
    }
  }

  validate() {
    return !this.required || this.hasValue;
  }
}
